/**
 * Show Element Action
 * Uses the existing runToggleVisibility with action='show' and unique event ID targeting
 */

import { runVisibilityToggle } from './runVisibilityToggle.jsx';

export const runElementShow = async (data = {}) => {
  try {
    const { eventId, targetEventId, ...otherData } = data;

    // Use targetEventId as selector if provided, otherwise use eventId
    const selector = targetEventId ? `#${targetEventId}` : eventId ? `#${eventId}` : 'body';

    return await runVisibilityToggle({
      action: 'show',
      selectors: [selector],
      ...otherData
    });
  } catch (error) {
    console.error('Show element error:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

export default runElementShow;
